module.exports = __webpack_public_path__ + "img/win_ball_blue.d469fba3.png";